export function initBreadcrumb(): void {
    const navs = document.querySelectorAll<HTMLElement>('.breadcrumb');
    navs.forEach((nav) => {
        const wrapper = nav.querySelector<HTMLElement>('.breadcrumb-wrapper');
        const list = nav.querySelector<HTMLElement>('.breadcrumb-list');
        if (!wrapper || !list) return;

        function updateOverflow(): void {
            const scrollLeft = list!.scrollLeft;
            const maxScroll = list!.scrollWidth - list!.clientWidth;
            wrapper!.classList.toggle('has-overflow-left', scrollLeft > 0);
            wrapper!.classList.toggle('has-overflow-right', maxScroll > 0 && scrollLeft < maxScroll - 1);
        }

        function pinToCurrentPage(): void {
            list!.scrollLeft = list!.scrollWidth;
            updateOverflow();
        }

        pinToCurrentPage();

        list.addEventListener('scroll', updateOverflow, { passive: true });
        window.addEventListener('resize', pinToCurrentPage, { passive: true });
    });
}
